import {
    FILTER_PARTNER_ON_CATEGORY,
    FILTER_PARTNER_ON_FIRST_LETTER,
    SORT_PARTNER_ON_NAME,
    SORT_PARTNER_ON_CASHBACK,
    SORT_PARTNER_ON_ORDER,
    SORT_PARTNER_ON_CREATION_DATE,
    SORT_PARTNER_ON_NB_COUPON,
    CLEAR_FILTER,
    CLEAR_SORT
} from './constants';

/**
 * Simple filter/sorter that do not stack filters but replace existing one for a given page
 */
const simple = type => (state, action, args = null) => ({
    ...state,
    [action.page]: {
        ...state[action.page],
        [type]: {
            type: action.type,
            args
        }
    }
});

const filters = (state = {}, action) => {
    switch (action.type) {
        case FILTER_PARTNER_ON_FIRST_LETTER:
            return simple('filter')(state, action, action.letter); // filterOnFirstLetter
        case FILTER_PARTNER_ON_CATEGORY:
            return simple('filter')(state, action, action.category); // filterOnCategory
        case SORT_PARTNER_ON_NAME:
            return simple('sorter')(state, action); // sortOnName
        case SORT_PARTNER_ON_CASHBACK:
            return simple('sorter')(state, action); // sortOnCashback
        case SORT_PARTNER_ON_ORDER:
            return simple('sorter')(state, action); // sortOnOrder
        case SORT_PARTNER_ON_CREATION_DATE:
            return simple('sorter')(state, action); // sortOnCreationDate
        case SORT_PARTNER_ON_NB_COUPON:
            return simple('sorter')(state, action); // sortOnNbCoupon
        case CLEAR_FILTER:
            return { [action.page]: { ...state[action.page], filter: {} } };
        case CLEAR_SORT:
            return { [action.page]: { ...state[action.page], sorter: {} } };
        default:
            return state;
    }
};

export default filters;



// WEBPACK FOOTER //
// ./src/services/filter/reducer.js